import React from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Link, RangePicker } from '@brokerbay/design-components';
import { featureEnabled } from 'utils';
import { Button } from 'components';
import { InvoiceSearchFilters } from '../types';

type ExtraProps = {
  openManageRecipients: () => void;
  filters: InvoiceSearchFilters;
  setFilters: React.Dispatch<React.SetStateAction<InvoiceSearchFilters>>;
  handleSendEmail: () => void;
  sendingBillingHistoryEmail: boolean;
};

const Extra: React.FC<ExtraProps> = ({
  openManageRecipients,
  filters,
  setFilters,
  handleSendEmail,
  sendingBillingHistoryEmail,
}) => {
  const handleDateChange = (
    _: [moment.Moment, moment.Moment],
    dateStrings: [string, string],
  ) => {
    // convert createdAfter to a js date with timestamp midnight
    const createdAfter = dateStrings?.[0]
      ? moment(dateStrings[0]).startOf('day').toDate()
      : undefined;

    // convert createdBefore to a js date with timestamp of 23:59:59
    const createdBefore = dateStrings?.[1]
      ? moment(dateStrings[1]).endOf('day').toDate()
      : undefined;

    setFilters(prev => ({
      ...prev,
      createdAfter,
      createdBefore,
    }));
  };

  return (
    <StyledWrapper>
      {
        // If this is not displaying Keyholder Billing invoices, allow
        // users to email their invoices externally.
        !featureEnabled('keyholderBillingFeature') && (
          <Link onClick={openManageRecipients}>Manage recipient(s)</Link>
        )
      }
      {featureEnabled('keyholderBillingFeature') && (
        <Button
          type="primary"
          loading={sendingBillingHistoryEmail}
          disabled={sendingBillingHistoryEmail}
          onClick={handleSendEmail}
        >
          Email Invoices
        </Button>
      )}
      <RangePicker
        onChange={handleDateChange}
        value={[
          filters.createdAfter
            ? moment(filters.createdAfter).startOf('day')
            : undefined,
          filters.createdBefore
            ? moment(filters.createdBefore).endOf('day')
            : undefined,
        ]}
        allowClear
      />
    </StyledWrapper>
  );
};

export default Extra;

const StyledWrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  align-items: center;
`;
